<template>
  <div class="selector__controls"
       :class="{'selector__controls--is-active': isFilterActive}"
  >
    <button class="selector__control selector__control--clear"
            @click="clearFilters"
    >
      <svg>
        <use xlink:href="#clear-cross"></use>
      </svg>

      {{ $t('header.filters.clear') }}
    </button>

    <button class="selector__control"
            @click="applyFilters"
    >
      {{ $t('header.filters.apply') }}
    </button>
  </div>
</template>

<script>
export default {
  name: "SelectorControls",
  props: {
    isFilterActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearFilters() {
      this.$emit('clear')
    },
    applyFilters() {
      this.$emit('apply')
    }
  }
}
</script>
